import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper-campaigns" }
const _hoisted_2 = { class: "above-info" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper-campaigns"
}
const _hoisted_4 = { class: "campaign-name" }
const _hoisted_5 = { class: "wrapper-icon-campaign" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "wrapper-image-campaign image1" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "empty"
}
const _hoisted_10 = { class: "wrapper-image-campaign image2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCreateEditCampaign = _resolveComponent("ModalCreateEditCampaign")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_EditButton = _resolveComponent("EditButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalCreateEditCampaign, {
      campaign: _ctx.selectedCampaign,
      onClose: _ctx.closeInformationCampaignModal,
      onCreate: _ctx.createCampaignTransaction,
      onEdit: _ctx.editCampaignTransaction,
      onRemove: _ctx.deleteAdditionalImageCampaignTransaction
    }, null, 8, ["campaign", "onClose", "onCreate", "onEdit", "onRemove"]), [
      [_vShow, _ctx.modalInfoCampaign]
    ]),
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deleteCampaignTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Campañas", -1)),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Crear campaña',
          onClick: _ctx.createNewCampaign
        }, null, 8, ["onClick"])
      ]),
      (_ctx.campaigns.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "campaign",
                key: index
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(campaign.campaignName), 1)
                ]),
                _createVNode(_component_EditButton, {
                  onClick: ($event: any) => (_ctx.editCampaignSelected(campaign))
                }, null, 8, ["onClick"]),
                _createVNode(_component_DeleteButton, {
                  onClick: ($event: any) => (_ctx.selectDeletedCampaign(campaign))
                }, null, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: campaign.icon,
                    alt: "",
                    class: "icon-campaign"
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (campaign.additional_image1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: campaign.additional_image1,
                        alt: "",
                        class: "image-campaign"
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Sin imagen.", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Necesaria para verse en la app móvil. ", -1)
                      ]))]))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (campaign.additional_image2)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: campaign.additional_image2,
                        alt: "",
                        class: "image-campaign"
                      }, null, 8, _hoisted_11))
                    : (_openBlock(), _createElementBlock("p", _hoisted_12, "Sin imagen"))
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}